import { useState } from "react";
import {
  Render_ar_number_cell,
  render_alert_cell,
  render_backlog_status_remarks_cell,
  render_completion_date_picker,
  render_remarks_cell,
} from "./utils/backlog_datagrid_cell_renderer";
import {
  reviewer_remark_status_column_properties,
  status_remark_status_column_properties,
} from "./utils/backlog_datagrid_common_column_properties";

import BacklogTimeDatePicker from "./components/BacklogTimeDatePicker";
// import { reviewer_remark_status_column_properties, test_status_column_properties } from "./utils/backlog_datagrid_common_column_properties";

const date_column_properties = {
  type: "date",
  valueGetter: ({ value }) => {
    if (typeof value === "object") return value;
    return value && new Date(value);
  },
};

// const getStatusIcon = (status) => {
//   return status ? (
//     <CheckCircleIcon style={{ color: "#4caf50" }} />
//   ) : (
//     <CancelIcon style={{ color: "#ff5722" }} />
//   );
// };

export const backlog_table_headers = {
  product_id: {
    name: "Product ID",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "Product ID",
    headerName: "PRODUCT ID",
  },
  product_name: {
    name: "Product Name",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "product_name",
    headerName: "PRODUCT NAME",
  },
  batch_number: {
    name: "Batch Number",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "batch_number",
    headerName: "BATCH NUMBER",
  },
  // "Lot Creation Date": {
  //     "name": "Lot Creation Date",
  //     // "type": null,
  //     "isDate": false,
  //     "isSelect": false,
  //     "isText": true,
  //     "needsDateInput": false,
  //     "visible": true,
  //     "editable": false,
  //     "field": "lot_creation_date",
  //     "headerName": "LOT CREATION DATE",
  //     ...date_column_properties
  // },
  "QC RECEIVE DATE": {
    name: "QC RECEIVE DATE",
    // "type": null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "qc_receive_date",
    headerName: "QC RECEIVE DATE",
    ...date_column_properties,
    type: "dateTime",
    renderCell: function CustomDatePicker(props) {
      const [, set_date] = useState({
        qc_receive_date: new Date(props?.value),
      });
      return <BacklogTimeDatePicker {...props} state_setter={set_date} />;
    },
  },
  market: {
    name: "Market",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "market",
    headerName: "MARKET",
  },
  interval: {
    name: "Spec ID",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "spec_id",
    headerName: "Spec ID",
  },
  "STP ID": {
    name: "STP ID",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "stp_id",
    headerName: "STP",
  },
  // "target_days_left": {
  //     "name": "target_days_left",
  //     "type": "number",
  //     "isDate": false,
  //     "isSelect": false,
  //     "isText": true,
  //     "needsDateInput": false,
  //     "visible": true,
  //     "editable": false,
  //     "field": "target_days_left",
  //     // "headerName": "NO. OF DAYS LEFT FOR COMPLETION OF ANALYSIS",
  //     "headerName": "TARGET DAYS LEFT",
  //     "width": 150
  // },
  // "target_date": {
  //     "name": "target_date",
  //     "type": null,
  //     "isDate": false,
  //     "isSelect": false,
  //     "isText": true,
  //     "needsDateInput": false,
  //     "visible": true,
  //     "editable": false,
  //     "field": "target_date",
  //     // "headerName": "TARGETED DATE FOR COMPLETION OF ANALYSIS",
  //     "headerName": "TARGETED COMPLETION DATE",
  //     "width": 200,
  //     ...date_column_properties,
  // },
  clubbed_sla_date: {
    name: "clubbed_sla_date",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "clubbed_sla_date",
    headerName: "CLUBBED SLA DATE",
    width: 150,
    ...date_column_properties,
  },
  sla_completion_date: {
    name: "sla_completion_date",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "sla_completion_date",
    headerName: "SLA COMPLETION DATE",
    width: 150,
    ...date_column_properties,
  },
  within_target: {
    name: "within_target",
    type: "boolean",
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "within_target",
    // "headerName": "NO. OF DAYS LEFT FOR COMPLETION OF ANALYSIS",
    headerName: "Within Target",
    width: 150,
  },
  completion_date: {
    name: "completion_date",
    type: null,
    isDate: true,
    isSelect: false,
    isText: false,
    needsDateInput: true,
    visible: true,
    editable: false,
    field: "Completion Date",
    headerName: "COMPLETION DATE",
    ...date_column_properties,
    renderCell: render_completion_date_picker,
  },
  "completed_within__(in_days)": {
    name: "completed_within__(in_days)",
    type: "number",
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    editable: false,
    field: "No of days",
    headerName: "COMPLETED WITHIN  (IN DAYS)",
    renderCell: render_alert_cell,
  },
  remarks: {
    name: "remarks",
    type: null,
    isDate: false,
    isSelect: true,
    isText: false,
    needsDateInput: false,
    visible: true,
    editable: false,
    select_options: "remark_status",
    field: "remark",
    headerName: "STATUS",
    ...status_remark_status_column_properties,
    renderCell: render_backlog_status_remarks_cell,
  },
  reviewers_remark: {
    name: "reviewers_remark",
    type: null,
    isDate: false,
    isSelect: true,
    isText: false,
    needsDateInput: false,
    visible: true,
    editable: false,
    select_options: "reviewer_remark_status",
    field: "reviewers_remark",
    headerName: "Reviewer Remark",
    ...reviewer_remark_status_column_properties,
    renderCell: render_remarks_cell,
  },
  age: {
    name: "age",
    type: "number",
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    field: "age",
    headerName: "AGE",
    width: 100,
  },
  id: {
    name: "id",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: false,
    field: "id",
    headerName: "ID",
  },
  ar_no: {
    name: "AR Number",
    type: null,
    isDate: false,
    isSelect: false,
    isText: true,
    needsDateInput: false,
    visible: true,
    field: "AR Number",
    headerName: "AR Number",
    editable: false,
    renderCell: Render_ar_number_cell,
  },
  sample_collector: {
    field: "sample_collector",
    headerName: "SAMPLE COLLECTOR",
    isEditable: false,
    width: 200,
  },
  sample_receiver: {
    field: "sample_receiver",
    headerName: "SAMPLE RECEIVER",
    isEditable: false,
    width: 200,
  },
  reviewer: {
    field: "reviewer",
    headerName: "REVIEWER",
    isEditable: false,
    width: 200,
  },
  approver: {
    field: "approver",
    headerName: "APPROVER",
    isEditable: false,
    width: 200,
  },
  storage_condition: {
    field: "storage_condition",
    headerName: "STORAGE CONDITION",
    isEditable: false,
    width: 200,
  },
};

// const x = {
//     "name": "ASSAY & CU_BY HPLC",
//     "type": "singleSelect",
//     "isDate": false,
//     "isSelect": true,
//     "isText": false,
//     "needsDateInput": false,
//     "visible": true,
//     "editable": false,
//     "select_options": "test_status",
//     "field": "ASSAY & CU_BY HPLC",
//     "headerName": "ASSAY & CU_BY HPLC",
//     renderCell: render_status_cell,
//     ...test_status_column_properties,
// };
